import React, { useContext } from 'react';
import { Route, Redirect, useLocation } from 'react-router-dom';

import PoweredBy from 'components/PoweredBy';
import CustomerSupport from 'components/CustomerSupport';
import UiKit from 'components/UiKit';
import Header from 'views/Templates/Store/Header';
import { AuthContext } from 'context/AuthContext';
import { ROUTES } from 'dictionary/routes';
import { router } from 'utils/routerUtils';

function Controller({ children = null }) {
  const { isLoggedIn } = useContext(AuthContext);
  const { pathname } = useLocation();

  if (!isLoggedIn) {
    const isRootPath = pathname === ROUTES.ROOT;
    const queryParams = isRootPath ? {} : { redirectTo: pathname };
    const route = router.getRouteWithParams(ROUTES.LOGIN, queryParams);
    return <Redirect to={route} />;
  }

  return (
    <>
      <Header />
      <UiKit.Container className="py-3">{children}</UiKit.Container>
      <div className="mt-auto">
        <CustomerSupport className="p-4" />
        <PoweredBy />
      </div>
    </>
  );
}

export function ProtectedRoute({ children = null, ...routeConfig }) {
  return (
    <Route {...routeConfig}>
      <Controller>{children}</Controller>
    </Route>
  );
}
